// Short, recognisable names for AWS services in the Spend page's service
// filter. Cost Explorer's own names are long ("Amazon Elastic Compute Cloud -
// Compute") and some are misleading on their own: there is no separate EBS
// service — EBS volumes and snapshots are billed under "EC2 - Other", along
// with NAT gateways and some data transfer — so that one says so.

const LABELS = {
  "Amazon Elastic Compute Cloud - Compute": "EC2 (instances)",
  "EC2 - Other": "EC2 other: EBS volumes, snapshots, NAT, data transfer",
  "Amazon Relational Database Service": "RDS (databases)",
  "Amazon Simple Storage Service": "S3 (storage)",
  "AWS Lambda": "Lambda",
  "Amazon Virtual Private Cloud": "VPC",
  "Amazon CloudFront": "CloudFront",
  "Elastic Load Balancing": "Load balancers (ELB)",
  "Amazon Elastic Load Balancing": "Load balancers (ELB)",
  "Amazon Elastic Container Service": "ECS (containers)",
  "Amazon Elastic Container Service for Kubernetes": "EKS (Kubernetes)",
  "Amazon EC2 Container Registry (ECR)": "ECR (container images)",
  "Amazon DynamoDB": "DynamoDB",
  "Amazon ElastiCache": "ElastiCache",
  "Amazon Elastic File System": "EFS (file systems)",
  "AWS Backup": "Backup",
  "Amazon Route 53": "Route 53 (DNS)",
  "Amazon CloudWatch": "CloudWatch",
  AmazonCloudWatch: "CloudWatch",
  "AWS Key Management Service": "KMS (encryption keys)",
  "AWS WAF": "WAF (web firewall)",
  "AWS Secrets Manager": "Secrets Manager",
  "Amazon Simple Email Service": "SES (email)",
  "Amazon Simple Notification Service": "SNS (notifications)",
  "Amazon Simple Queue Service": "SQS (queues)",
  "Amazon GuardDuty": "GuardDuty",
  "AWS Config": "Config",
  "AWS CloudTrail": "CloudTrail",
  "Amazon API Gateway": "API Gateway",
  "AWS Transfer Family": "Transfer Family (SFTP)",
  "Amazon WorkSpaces": "WorkSpaces",
  "AWS Directory Service": "Directory Service",
  "Amazon FSx": "FSx",
  "AWS Systems Manager": "Systems Manager",
  Tax: "Tax",
};

/** "Amazon Relational Database Service" → "RDS (databases)"; unknown names lose their Amazon/AWS prefix. */
export function serviceLabel(service) {
  return LABELS[service] || (service || "").replace(/^(Amazon|AWS)\s+/i, "");
}
